var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "tabSettlement" } },
    [
      _vm.balanceVisible
        ? _c(
            "div",
            {
              staticClass: "va-row mb-5",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex md2 xs12" },
                [
                  _c("vuestic-widget", { staticClass: "info-widget" }, [
                    _c(
                      "div",
                      { staticClass: "info-widget-inner" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-title mb-2",
                            staticStyle: { "min-height": "80px" },
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(_vm._f("translate")("t.totalAmount"))
                              ),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("t.processingFeeIncluded")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.totalAmount, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "w-content" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getJsonKey(item)) +
                                    "    " +
                                    _vm._s(_vm.getJsonValue(item))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md2 xs12" },
                [
                  _c("vuestic-widget", { staticClass: "info-widget" }, [
                    _c(
                      "div",
                      { staticClass: "info-widget-inner" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-title mb-2",
                            staticStyle: { "min-height": "80px" },
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(_vm._f("translate")("t.netIncome"))
                              ),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("t.processingFeeDeducted")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.netIncome, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "w-content" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getJsonKey(item)) +
                                    "    " +
                                    _vm._s(_vm.getJsonValue(item))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md2 xs12" },
                [
                  _c("vuestic-widget", { staticClass: "info-widget" }, [
                    _c(
                      "div",
                      { staticClass: "info-widget-inner" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-title mb-2",
                            staticStyle: { "min-height": "80px" },
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm._f("translate")("t.balance"))),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("t.processingFeeDeducted")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.balance, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "w-content" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getJsonKey(item)) +
                                    "    " +
                                    _vm._s(_vm.getJsonValue(item))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _vm.settlementAmount
                ? _c(
                    "div",
                    { staticClass: "flex md2 xs12" },
                    [
                      _c("vuestic-widget", { staticClass: "info-widget" }, [
                        _c(
                          "div",
                          { staticClass: "info-widget-inner" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-title mb-2",
                                staticStyle: { "min-height": "80px" },
                              },
                              [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")("t.settlementAmount")
                                    )
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "t.processingFeeDeducted"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(
                              _vm.settlementAmount,
                              function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "w-content" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getJsonKey(item)) +
                                          "    " +
                                          _vm._s(_vm.getJsonValue(item))
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.payout
                ? _c(
                    "div",
                    {
                      staticClass: "flex md2 xs12",
                      staticStyle: { position: "relative" },
                    },
                    [
                      _c("vuestic-widget", { staticClass: "info-widget" }, [
                        _c(
                          "div",
                          { staticClass: "info-widget-inner" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-title mb-2",
                                staticStyle: { "min-height": "80px" },
                              },
                              [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("t.withdraw"))
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "t.processingFeeDeducted"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(_vm.payout, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "w-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getJsonKey(item)) +
                                        "    " +
                                        _vm._s(_vm.getJsonValue(item))
                                    ),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "flex va-row mt-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-micro",
                              staticStyle: { position: "absolute", left: "0" },
                              on: { click: _vm.createWithdraw },
                            },
                            [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("t.createWithdraw")
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.reserveArray
                ? _c(
                    "div",
                    { staticClass: "flex md2 xs12" },
                    [
                      _c("vuestic-widget", { staticClass: "info-widget" }, [
                        _c(
                          "div",
                          { staticClass: "info-widget-inner" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-title mb-2",
                                staticStyle: { "min-height": "80px" },
                              },
                              [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("t.reserve"))
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "t.processingFeeDeducted"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(_vm.reserveArray, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "w-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getJsonKey(item)) +
                                        "    " +
                                        _vm._s(_vm.getJsonValue(item))
                                    ),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "tabs",
        {
          ref: "financeTabs",
          attrs: { options: { useUrlFragment: false } },
          on: { clicked: _vm.tabClicked, changed: _vm.tabChanged },
        },
        [
          _vm.settlementAmount || _vm.balanceVisible
            ? _c("tab", { attrs: { name: "Sales Statement" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.salesPostData.salesView,
                        expression: "salesPostData.salesView",
                      },
                    ],
                    staticClass: "billed-info",
                  },
                  [
                    _c("section", { staticClass: "flex md12 xs12" }, [
                      _c(
                        "div",
                        { staticClass: "flex md12 xs12 p-l-20" },
                        [
                          _c("label", { staticClass: "select-title" }, [
                            _vm._v("CreateDate："),
                          ]),
                          _c("date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              range: "",
                              format: _vm.momentFormat,
                              placeholder: "Start Day  ~  End Day",
                            },
                            model: {
                              value: _vm.sales.dates,
                              callback: function ($$v) {
                                _vm.$set(_vm.sales, "dates", $$v)
                              },
                              expression: "sales.dates",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "account-statement",
                              attrs: { type: "success" },
                              on: { click: _vm.querySalesList },
                            },
                            [_vm._v("Search")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "dataGrid-settlement" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.sales.tableData,
                                "default-sort": {
                                  prop: "create_time",
                                  order: "descending",
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "ID", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "green-id-fetch-info",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.saleIdCk(
                                                    $event,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.id))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  933100659
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_time",
                                  label: "CREATE DATE",
                                  sortable: "",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "period_date",
                                  label: "REPORT PERIOD",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "total_processing_fee",
                                  label: "TOTAL AMOUNT",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payout_amount",
                                  label: "SETTLEABLE AMOUNT",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payout_status",
                                  label: "SETTLEMENT STATUS",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payout_date",
                                  label: "SETTLEMENT DATE",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: "REPORTS" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "down-load",
                                              attrs: { size: "small" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleDownLoad(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("download")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  274934671
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sales.total > _vm.sales.limit,
                                  expression: "sales.total > sales.limit",
                                },
                              ],
                              staticClass: "block",
                            },
                            [
                              _c("pagination", {
                                attrs: {
                                  total: _vm.sales.total,
                                  layout:
                                    "total, sizes, prev, pager, next, jumper",
                                  background: "",
                                  "page-size": _vm.sales.limit,
                                  page: _vm.sales.pageNO,
                                  limit: _vm.sales.limit,
                                  "page-sizes": [10, 20, 30, 40, 50, 100],
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(_vm.sales, "pageNO", $event)
                                  },
                                  "update:limit": function ($event) {
                                    return _vm.$set(_vm.sales, "limit", $event)
                                  },
                                  pagination: _vm.querySalesList,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.salesPostData.salesView &&
                          _vm.salesPostData.saleNo,
                        expression:
                          "!salesPostData.salesView && salesPostData.saleNo",
                      },
                    ],
                    staticClass: "billed-one-details",
                  },
                  [
                    _c("h6", { staticClass: "bill-detail-title p-l-baseF" }, [
                      _c("b", [_vm._v("Sales Statement")]),
                      _c(
                        "span",
                        { staticClass: "m-l-baseF Light-color-character" },
                        [_vm._v(_vm._s(_vm.salesPostData.saleNo))]
                      ),
                    ]),
                    _c("section", { staticClass: "bill-detail-info" }, [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md6" }, [
                          _c("label", { staticClass: "lb-w-l p-l-baseF" }, [
                            _vm._v("Report Period:"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "m-l-baseF Light-color-character" },
                            [_vm._v(_vm._s(_vm.salesPostData.period_date))]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md6" }, [
                          _c("label", { staticClass: "lb-w-r-add20" }, [
                            _vm._v("Report Generated Date:"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "m-l-baseF Light-color-character" },
                            [_vm._v(_vm._s(_vm.salesPostData.payout_date))]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "section",
                      { staticClass: "statistics" },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "report-detail",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.saleDetails },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "postage", label: "DESCRIPTION" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "successMoney", label: "Success" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "changebackMoney",
                                label: "Charegeback",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "refundMoney", label: "Refund" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "total",
                                label: "Total",
                                "class-name": "light-green",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "flex md12 xs12 statistics" }, [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex md4" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-micro",
                              on: {
                                click: function ($event) {
                                  return _vm.goBack("sales")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "btn-with-icon-content" },
                                [_vm._v("Back")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.settlementAmount || _vm.balanceVisible
            ? _c("tab", { attrs: { name: "Settlement Reports" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.reportsPostData.reportsView,
                        expression: "reportsPostData.reportsView",
                      },
                    ],
                    staticClass: "page report-wrap",
                    attrs: { id: "tabSettleReport" },
                  },
                  [
                    _c("section", { staticClass: "flex md12 xs12" }, [
                      _c(
                        "div",
                        { staticClass: "flex md12 xs12" },
                        [
                          _c("label", { staticClass: "select-title" }, [
                            _vm._v("Settlement Date："),
                          ]),
                          _c("date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              range: "",
                              format: _vm.momentFormat,
                              placeholder: "Start Day  ~  End Day",
                            },
                            model: {
                              value: _vm.reports.dates,
                              callback: function ($$v) {
                                _vm.$set(_vm.reports, "dates", $$v)
                              },
                              expression: "reports.dates",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "account-statement",
                              attrs: { type: "success" },
                              on: { click: _vm.queryReportsList },
                            },
                            [_vm._v("Search")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "dataGrid-report" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.reports.tableData,
                                "default-sort": {
                                  prop: "settlement_date",
                                  order: "ascending",
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "ID" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "green-id-fetch-info",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.reportIdCk(
                                                    $event,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.id))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3947080902
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sale_statement_id",
                                  label: "SALES STATEMENT ID",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "settlement_date",
                                  label: "SETTLEMENT DATE",
                                  sortable: "",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: "REPORTS" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "down-load",
                                              attrs: { size: "small" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleDownLoad(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("download")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  274934671
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.reports.total > _vm.reports.limit,
                                  expression: "reports.total > reports.limit",
                                },
                              ],
                              staticClass: "block",
                            },
                            [
                              _c("pagination", {
                                attrs: {
                                  total: _vm.reports.total,
                                  layout:
                                    "total, sizes, prev, pager, next, jumper",
                                  background: "",
                                  "page-size": _vm.reports.limit,
                                  page: _vm.reports.pageNO,
                                  limit: _vm.reports.limit,
                                  "page-sizes": [10, 20, 30, 40, 50, 100],
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.reports,
                                      "pageNO",
                                      $event
                                    )
                                  },
                                  "update:limit": function ($event) {
                                    return _vm.$set(
                                      _vm.reports,
                                      "limit",
                                      $event
                                    )
                                  },
                                  pagination: _vm.queryReportsList,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.reportsPostData.reportsView &&
                          _vm.reportsPostData.reportNO,
                        expression:
                          "!reportsPostData.reportsView && reportsPostData.reportNO",
                      },
                    ],
                    staticClass: "billed-one-details",
                  },
                  [
                    _c("h6", { staticClass: "bill-detail-title p-l-baseF" }, [
                      _c("b", [_vm._v("Settlement Report")]),
                      _c(
                        "span",
                        { staticClass: "m-l-baseF Light-color-character" },
                        [_vm._v(_vm._s(_vm.reportsPostData.reportNO))]
                      ),
                    ]),
                    _c("section", { staticClass: "bill-detail-info" }, [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md6" }, [
                          _c("label", { staticClass: "lb-w-l p-l-baseF" }, [
                            _vm._v("Report Period:"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "m-l-baseF Light-color-character" },
                            [_vm._v(_vm._s(_vm.reportsPostData.period_date))]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md6" }, [
                          _c("label", { staticClass: "lb-w-r-add20" }, [
                            _vm._v("Report Generated Date:"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "m-l-baseF Light-color-character" },
                            [_vm._v(_vm._s(_vm.reportsPostData.payout_date))]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md6" }, [
                          _c("label", { staticClass: "lb-w-l p-l-baseF" }, [
                            _vm._v("Exchange Rate:"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "m-l-baseF Light-color-character" },
                            [_vm._v(_vm._s(_vm.reportsPostData.rate))]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md6" }, [
                          _c("label", { staticClass: "lb-w-r-add20" }, [
                            _vm._v("Sales Statement ID:"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "m-l-baseF Light-color-character" },
                            [
                              _vm._v(
                                _vm._s(_vm.reportsPostData.sale_statement_id)
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "section",
                      { staticClass: "statistics" },
                      [
                        _c("report-details", {
                          attrs: { "table-data": _vm.currentSelectedDetail },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "flex md12 xs12 statistics" }, [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex md4" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-micro",
                              on: {
                                click: function ($event) {
                                  return _vm.goBack("reports")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "btn-with-icon-content" },
                                [_vm._v("Back")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.settlementAmount || _vm.balanceVisible
            ? _c("tab", { attrs: { name: "Invoice" } }, [
                _c(
                  "div",
                  {
                    staticClass: "page invoice-wrap",
                    attrs: { id: "tabInvoice" },
                  },
                  [
                    _c("section", { staticClass: "flex md12 xs12" }, [
                      _c(
                        "div",
                        { staticClass: "flex md12 xs12" },
                        [
                          _c("label", { staticClass: "select-title" }, [
                            _vm._v("CreateDate："),
                          ]),
                          _c("date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              range: "",
                              format: _vm.momentFormat,
                              placeholder: "Start Day  ~  End Day",
                            },
                            model: {
                              value: _vm.invoices.dates,
                              callback: function ($$v) {
                                _vm.$set(_vm.invoices, "dates", $$v)
                              },
                              expression: "invoices.dates",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "account-statement",
                              attrs: { type: "success" },
                              on: { click: _vm.queryInvoiceList },
                            },
                            [_vm._v("Search")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "dataGrid-report" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.invoices.tableData,
                                "default-sort": {
                                  prop: "settlement_date",
                                  order: "ascending",
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "ID" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.id)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  773642443
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "settlement_id",
                                  label: "SETTLEMENT ID",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_date",
                                  label: "DATE",
                                  sortable: "",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: "REPORTS" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "down-load",
                                              attrs: { size: "small" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleDownLoad(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("download")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  274934671
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.invoices.total > _vm.invoices.limit,
                                  expression: "invoices.total > invoices.limit",
                                },
                              ],
                              staticClass: "block",
                            },
                            [
                              _c("pagination", {
                                attrs: {
                                  total: _vm.invoices.total,
                                  layout:
                                    "total, sizes, prev, pager, next, jumper",
                                  background: "",
                                  "page-size": _vm.invoices.limit,
                                  page: _vm.invoices.pageNO,
                                  limit: _vm.invoices.limit,
                                  "page-sizes": [10, 20, 30, 40, 50, 100],
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.invoices,
                                      "pageNO",
                                      $event
                                    )
                                  },
                                  "update:limit": function ($event) {
                                    return _vm.$set(
                                      _vm.invoices,
                                      "limit",
                                      $event
                                    )
                                  },
                                  pagination: _vm.queryInvoiceList,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.payout && _vm.balanceVisible
            ? _c("tab", { attrs: { name: _vm.$t("t.payoutHistory") } }, [
                _c(
                  "div",
                  {
                    staticClass: "page invoice-wrap",
                    attrs: { id: "tabPayoutHistory" },
                  },
                  [
                    _c("section", { staticClass: "flex md12 xs12" }, [
                      _c(
                        "div",
                        { staticClass: "flex md12 xs12" },
                        [
                          _c("label", { staticClass: "select-title" }, [
                            _vm._v(
                              _vm._s(_vm._f("translate")("t.createDate")) + "："
                            ),
                          ]),
                          _c("date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              range: "",
                              format: _vm.momentFormat,
                              placeholder: "Start Day  ~  End Day",
                            },
                            model: {
                              value: _vm.payoutHistory.dates,
                              callback: function ($$v) {
                                _vm.$set(_vm.payoutHistory, "dates", $$v)
                              },
                              expression: "payoutHistory.dates",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "account-statement",
                              attrs: { type: "success" },
                              on: { click: _vm.queryPayoutHistory },
                            },
                            [_vm._v(_vm._s(_vm.$t("basic.button.search")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "dataGrid-report" },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "dataGrid-report-table",
                              attrs: {
                                data: _vm.payoutHistory.tableData,
                                "tooltip-effect": "light",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "min-width": "240",
                                  prop: "withdraw_id",
                                  label: "ID",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "min-width": "150",
                                  prop: "desc",
                                  label: _vm.$t("t.remark"),
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "min-width": "100",
                                  prop: "request_currency",
                                  label: _vm.$t("t.currency"),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "min-width": "150",
                                  prop: "request_amount",
                                  label: _vm.$t("tables.listing.amount"),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "min-width": "150",
                                  prop: "create_time",
                                  label: _vm.$t(
                                    "tables.listing.recurring_create_time"
                                  ),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "status",
                                  label: _vm.$t("tables.listing.status"),
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.payoutHistory.total >
                                    _vm.payoutHistory.pageSize,
                                  expression:
                                    "payoutHistory.total > payoutHistory.pageSize",
                                },
                              ],
                              staticClass: "block",
                            },
                            [
                              _c("pagination", {
                                attrs: {
                                  total: _vm.payoutHistory.total,
                                  layout:
                                    "total, sizes, prev, pager, next, jumper",
                                  background: "",
                                  "page-size": _vm.payoutHistory.pageSize,
                                  page: _vm.payoutHistory.pageNum,
                                  limit: _vm.payoutHistory.pageSize,
                                  "page-sizes": [10, 50, 100],
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.payoutHistory,
                                      "pageNum",
                                      $event
                                    )
                                  },
                                  "update:limit": function ($event) {
                                    return _vm.$set(
                                      _vm.payoutHistory,
                                      "pageSize",
                                      $event
                                    )
                                  },
                                  pagination: _vm.queryPayoutHistory,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.payout && _vm.balanceVisible
            ? _c(
                "tab",
                { attrs: { name: "Bank History" } },
                [_c("bank-withdrawal", { ref: "bankWithdrawalComponent" })],
                1
              )
            : _vm._e(),
          _vm.payout && _vm.balanceVisible
            ? _c(
                "tab",
                { attrs: { name: "VA History" } },
                [_c("virtual-account", { ref: "virtualAccountComponent" })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vuestic-modal",
        {
          ref: "withdraw",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.withdrawDialogVisible,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
            large: true,
          },
          on: {
            "update:show": function ($event) {
              _vm.withdrawDialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("Withdraw"),
          ]),
          _c(
            "tabs",
            {
              ref: "withdrawTabs",
              attrs: { options: { useUrlFragment: false } },
              on: {
                clicked: _vm.withdrawTabClicked,
                changed: _vm.withdrawTabClicked,
              },
            },
            [
              _c("tab", { attrs: { name: "To Payout" } }, [
                _c("form", { staticStyle: { padding: "20px" } }, [
                  _c("div", { staticClass: "va-row" }, [
                    _c("div", { staticClass: "flex xs12 md12" }, [
                      _c("fieldset", { staticClass: "withdraw-modal" }, [
                        _c("div", { staticClass: "info-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.initCurrencyVaild,
                                valid: _vm.isCurrencyValid("currency"),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("vuestic-kyc-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "currencyInput",
                                      name: "currency",
                                      "data-vv-as": "Currency",
                                      required: "",
                                      label: "Currency：",
                                      "option-key": "label",
                                      options: _vm.currencies,
                                      autocomplete: "off",
                                    },
                                    on: {
                                      input: (val) => {
                                        _vm.currencyStatus = !val ? true : false
                                        _vm.generateExchangeRate()
                                      },
                                    },
                                    model: {
                                      value: _vm.withdrawData.currency,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.withdrawData,
                                          "currency",
                                          $$v
                                        )
                                      },
                                      expression: "withdrawData.currency",
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass: "fa icon-right input-icon",
                                  }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.initCurrencyVaild,
                                          expression: "initCurrencyVaild",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("currency"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "info-group-space" }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-group with-icon-right withdraw-to-close",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("vuestic-kyc-select", {
                                    attrs: {
                                      disabled: true,
                                      name: "withdrawTo",
                                      "data-vv-as": "Withdraw to",
                                      label: `${_vm.$t("t.withdrawTo")}：`,
                                      "option-key": "label",
                                      options: _vm.withdrawToOption,
                                      autocomplete: "off",
                                    },
                                    on: { input: _vm.withdrawToChange },
                                    model: {
                                      value: _vm.withdrawTo,
                                      callback: function ($$v) {
                                        _vm.withdrawTo = $$v
                                      },
                                      expression: "withdrawTo",
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass: "fa icon-right input-icon",
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "info-group" }, [
                          _vm.isBank
                            ? _c(
                                "div",
                                { staticClass: "form-group with-icon-right" },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.settlementFee,
                                          expression: "settlementFee",
                                        },
                                      ],
                                      attrs: {
                                        name: "settlementFee",
                                        "data-vv-as": "Settlement Fee",
                                        autocomplete: "off",
                                        disabled: true,
                                      },
                                      domProps: { value: _vm.settlementFee },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.settlementFee =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "settlementFee" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")(
                                              "t.settlementFee"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          !_vm.isBank
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group with-icon-right withdraw-to-close",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.initPayoutAccounts,
                                        valid:
                                          _vm.isPayoutAccountsValid(
                                            "payoutAccounts"
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("vuestic-kyc-select", {
                                            attrs: {
                                              name: "Payout Accounts",
                                              "data-vv-as": "Payout Accounts",
                                              label: "Payout Accounts：",
                                              "option-key": "account_name",
                                              "option-value": "account_id",
                                              options:
                                                _vm.payoutAccountsOptions,
                                              autocomplete: "off",
                                            },
                                            on: {
                                              input: (val) => {
                                                _vm.payoutAccountsStatus = !val
                                                  ? true
                                                  : false
                                                _vm.payoutAccountsChange(val)
                                              },
                                            },
                                            model: {
                                              value: _vm.payoutAccounts,
                                              callback: function ($$v) {
                                                _vm.payoutAccounts = $$v
                                              },
                                              expression: "payoutAccounts",
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa icon-right input-icon",
                                          }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.initPayoutAccounts,
                                                  expression:
                                                    "initPayoutAccounts",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "payoutAccounts"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "info-group-space" }),
                          _vm.isBank
                            ? _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error": _vm.errors.has("amount"),
                                    valid: _vm.isFormFieldValid("amount"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.withdrawData.amount,
                                          expression: "withdrawData.amount",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        name: "amount",
                                        "data-vv-as": "Amount",
                                        autocomplete: "off",
                                        type: "text",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.withdrawData.amount,
                                      },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.withdrawData,
                                              "amount",
                                              $event.target.value
                                            )
                                          },
                                          _vm.changeAmountValue,
                                        ],
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "amount" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")("t.amount")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has("amount"),
                                            expression: "errors.has('amount')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("amount"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          !_vm.isBank
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group with-icon-right withdraw-to-close",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.initArrivedCurrency,
                                        valid:
                                          _vm.isArrivedCurrencyValid(
                                            "arrivedCurrency"
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("vuestic-kyc-select", {
                                            attrs: {
                                              name: "arrivedCurrency",
                                              "data-vv-as": "Arrived Currency",
                                              label: "Arrived Currency：",
                                              options:
                                                _vm.arrivedCurrencyOption,
                                              autocomplete: "off",
                                            },
                                            on: {
                                              input: (val) => {
                                                _vm.arrivedCurrencyStatus = !val
                                                  ? true
                                                  : false
                                                _vm.arrivedCurrencyChange()
                                              },
                                            },
                                            model: {
                                              value: _vm.arrivedCurrency,
                                              callback: function ($$v) {
                                                _vm.arrivedCurrency = $$v
                                              },
                                              expression: "arrivedCurrency",
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa icon-right input-icon",
                                          }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.initArrivedCurrency,
                                                  expression:
                                                    "initArrivedCurrency",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "arrivedCurrency"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        !_vm.isBank
                          ? _c("div", { staticClass: "info-group" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error": _vm.errors.has("amount"),
                                    valid: _vm.isFormFieldValid("amount"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.withdrawData.amount,
                                          expression: "withdrawData.amount",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        name: "amount",
                                        "data-vv-as": "Amount",
                                        autocomplete: "off",
                                        type: "text",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.withdrawData.amount,
                                      },
                                      on: {
                                        change: _vm.amountChange,
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.withdrawData,
                                              "amount",
                                              $event.target.value
                                            )
                                          },
                                          _vm.changeAmountValue,
                                        ],
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "amount" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")("t.amount")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has("amount"),
                                            expression: "errors.has('amount')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("amount"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c("div", { staticClass: "info-group-space" }),
                              _c(
                                "div",
                                { staticClass: "form-group with-icon-right" },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.arrivedAmount,
                                          expression: "arrivedAmount",
                                        },
                                      ],
                                      attrs: {
                                        name: "arrivedAmount",
                                        "data-vv-as": "Arrived Amount",
                                        autocomplete: "off",
                                        disabled: true,
                                      },
                                      domProps: { value: _vm.arrivedAmount },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.arrivedAmount =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "arrivedAmount" },
                                      },
                                      [_vm._v("Arrived Amount")]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isBank,
                                expression: "!isBank",
                              },
                            ],
                            staticClass: "info-group",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group with-icon-right" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.exchangeRate,
                                          expression: "exchangeRate",
                                        },
                                      ],
                                      attrs: {
                                        name: "exchangeRate",
                                        "data-vv-as": "exchangeRate",
                                        autocomplete: "off",
                                        disabled: true,
                                      },
                                      domProps: { value: _vm.exchangeRate },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.exchangeRate = $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "exchangeRate" },
                                      },
                                      [_vm._v("Exchange Rate ")]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content:
                                            "According to local regulations we need to take the funds outside the territory and bring them back for local payouts, because of that the available balance in local currency needs to be converted into USD, then back to the local currency. And the FX is applied during the conversion.",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "info-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.errors.has("remark"),
                                valid: _vm.isFormFieldValid("remark"),
                              },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.withdrawData.remark,
                                      expression: "withdrawData.remark",
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: {
                                    name: "remark",
                                    "data-vv-as": "Remark",
                                    autocomplete: "off",
                                    maxlength: "200",
                                    required: "",
                                  },
                                  domProps: { value: _vm.withdrawData.remark },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.withdrawData,
                                        "remark",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "remark" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm._f("translate")("t.remark"))
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("remark"),
                                        expression: "errors.has('remark')",
                                      },
                                    ],
                                    staticClass: "help text-danger",
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("remark")))]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c("tab", { attrs: { name: "To Bank" } }, [
                _c(
                  "form",
                  { staticStyle: { padding: "20px" } },
                  [
                    _c("div", { staticClass: "va-row" }, [
                      _c("div", { staticClass: "flex xs12 md6" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group with-icon-right mb-2",
                            class: {
                              "has-error": _vm.withdrawToBankStatus,
                              valid:
                                _vm.isWithdrawToBankValid("withdrawToBank"),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c("vuestic-kyc-select", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  staticClass: "withdraw-to-bank",
                                  attrs: {
                                    name: "withdrawToBank",
                                    "data-vv-as": "Withdraw To Bank",
                                    required: "",
                                    label: "Withdraw to：",
                                    options: _vm.withdrawToBankOption,
                                    "option-key": "label",
                                    autocomplete: "off",
                                  },
                                  on: {
                                    input: (val) => {
                                      _vm.withdrawToBankStatus = !val
                                        ? true
                                        : false
                                      _vm.withdrawToBankChange(val)
                                    },
                                  },
                                  model: {
                                    value: _vm.withdrawToBank,
                                    callback: function ($$v) {
                                      _vm.withdrawToBank = $$v
                                    },
                                    expression: "withdrawToBank",
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass: "fa icon-right input-icon",
                                }),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.withdrawToBankStatus,
                                        expression: "withdrawToBankStatus",
                                      },
                                    ],
                                    staticClass: "help text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "The Withdraw To Bank field is required."
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "va-row" }, [
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Currency：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.accountInfo.currency) + " ")]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Account Number：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.accountInfo.account_number) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Account Name：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.accountInfo.account_name) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Bank Name：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.accountInfo.bank_name) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Country：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.accountInfo.country) + " ")]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Branch：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.accountInfo.branch) + " ")]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("SWIFT：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.accountInfo.swift_code) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("Address：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.accountInfo.address) + " ")]
                        ),
                      ]),
                      _c("div", { staticClass: "flex xs12 md4" }, [
                        _c("span", [_vm._v("IBAN：")]),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "word-break": "break-all",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.accountInfo.iban) + " ")]
                        ),
                      ]),
                    ]),
                    _vm._l(_vm.bankWithdrawData, function (item, index) {
                      return _c("div", { key: index, staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": item[`bankCurrencyStatus${index}`],
                                valid: _vm.isBankCurrencyValid(item),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("vuestic-kyc-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    staticClass: "withdraw-tobank-currency",
                                    attrs: {
                                      name: `Currency ${index}：`,
                                      "data-vv-as": `Currency ${index}：`,
                                      required: "",
                                      label: `Currency：`,
                                      "option-key": "label",
                                      options: _vm.newCurrencies,
                                      autocomplete: "off",
                                    },
                                    on: {
                                      input: (val) => {
                                        item[`bankCurrencyStatus${index}`] =
                                          !val ? true : false
                                        item["balance"] = val.balance
                                        // $validator.validate(`bankAmountWithdraw${index}`);
                                      },
                                    },
                                    model: {
                                      value: item["currency"],
                                      callback: function ($$v) {
                                        _vm.$set(item, "currency", $$v)
                                      },
                                      expression: "item['currency']",
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass: "fa icon-right input-icon",
                                  }),
                                  item[`bankCurrencyStatus${index}`]
                                    ? _c(
                                        "small",
                                        { staticClass: "help text-danger" },
                                        [
                                          _vm._v(
                                            "The Currency " +
                                              _vm._s(index + 1) +
                                              " field is required."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md2" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item["balance"],
                                      expression: "item['balance']",
                                    },
                                  ],
                                  attrs: {
                                    name: "Balance",
                                    "data-vv-as": "Balance",
                                    autocomplete: "off",
                                    disabled: true,
                                  },
                                  domProps: { value: item["balance"] },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "balance",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "bank-balance" },
                                  },
                                  [_vm._v("Balance")]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.errors.has(
                                  `bankAmountWithdraw${index}`
                                ),
                                valid: _vm.isFormFieldValid(
                                  `bankAmountWithdraw${index}`
                                ),
                              },
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item["amount"],
                                      expression: "item['amount']",
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: `required|verifyWithdrawAmount:${index}`,
                                      expression:
                                        "`required|verifyWithdrawAmount:${index}`",
                                    },
                                  ],
                                  attrs: {
                                    name: `bankAmountWithdraw${index}`,
                                    "data-vv-as": `Amount for Withdrawal ${
                                      index + 1
                                    }`,
                                    autocomplete: "off",
                                    type: "text",
                                    required: "",
                                    oninput:
                                      "if(!value){value=''}else if(value.charAt(0)==='0'&&value.charAt(1)&&value.charAt(1)!=='.'){value='0'};value = value.replace(/[^\\d.]/g, '');value=value.replace(/\\.{2,}/g, '.');value=value.match(/^\\d*(\\.?\\d{0,2})/g)[0] || '';",
                                  },
                                  domProps: { value: item["amount"] },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "amount",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "bankAmountWithdraw" },
                                  },
                                  [_vm._v("Amount for Withdrawal")]
                                ),
                                _c("i", { staticClass: "bar" }),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          `bankAmountWithdraw${index}`
                                        ),
                                        expression:
                                          "errors.has(`bankAmountWithdraw${index}`)",
                                      },
                                    ],
                                    staticClass: "help text-danger",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          `bankAmountWithdraw${index}`
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _vm.bankWithdrawData.length - 1 === index
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-micro",
                                        staticStyle: { "margin-right": "10px" },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addBankCurrency(index)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fa fa-plus" })]
                                    )
                                  : _vm._e(),
                                _vm.bankWithdrawData.length > 1
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-micro",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.minusBankCurrency(index)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fa fa-minus" })]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    _c("div", { staticClass: "va-row" }, [
                      _c("div", { staticClass: "flex xs12 md12" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group with-icon-right",
                            class: {
                              "has-error": _vm.errors.has("bankRemark"),
                              valid: _vm.isFormFieldValid("bankRemark"),
                            },
                          },
                          [
                            _c("div", { staticClass: "input-group" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.bankRemark,
                                    expression: "bankRemark",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  name: "bankRemark",
                                  "data-vv-as": "BankRemark",
                                  autocomplete: "off",
                                  maxlength: "200",
                                  required: "",
                                },
                                domProps: { value: _vm.bankRemark },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.bankRemark = $event.target.value
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-check valid-icon icon-right input-icon",
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "bankRemark" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("t.remark"))
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("bankRemark"),
                                      expression: "errors.has('bankRemark')",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [_vm._v(_vm._s(_vm.errors.first("bankRemark")))]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ]),
              _c("tab", { attrs: { name: "To VA" } }, [
                _c(
                  "form",
                  { staticStyle: { padding: "20px" } },
                  [
                    _c("div", { staticClass: "va-row" }, [
                      _c("div", { staticClass: "flex xs12 md6" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group with-icon-right mb-2",
                            class: {
                              "has-error": _vm.errors.has("virtualAccount"),
                              valid: _vm.isFormFieldValid("virtualAccount"),
                            },
                          },
                          [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.virtualAccount,
                                    expression: "virtualAccount",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  name: "virtualAccount",
                                  "data-vv-as": "Virtual Account Number",
                                  autocomplete: "off",
                                  type: "text",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                },
                                domProps: { value: _vm.virtualAccount },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.virtualAccount = $event.target.value
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-check valid-icon icon-right input-icon",
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "virtualAccount" },
                                },
                                [_vm._v("Virtual Account Number")]
                              ),
                              _c("i", { staticClass: "bar" }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("virtualAccount"),
                                      expression:
                                        "errors.has('virtualAccount')",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.errors.first("virtualAccount"))
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._l(_vm.virtualAccountData, function (item, index) {
                      return _c("div", { key: index, staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error":
                                  item[`accountCurrencyStatus${index}`],
                                valid: _vm.isAccountCurrencyValid(item),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("vuestic-kyc-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    staticClass: "withdraw-tobank-currency",
                                    attrs: {
                                      name: `Currency ${index}：`,
                                      "data-vv-as": `Currency ${index}：`,
                                      required: "",
                                      label: `Currency：`,
                                      "option-key": "label",
                                      options: _vm.newAccountCurrencies,
                                      autocomplete: "off",
                                    },
                                    on: {
                                      input: (val) => {
                                        item[`accountCurrencyStatus${index}`] =
                                          !val ? true : false
                                        item["balance"] = val.balance
                                        // $validator.validate(`accountAmountWithdraw${index}`);
                                      },
                                    },
                                    model: {
                                      value: item["currency"],
                                      callback: function ($$v) {
                                        _vm.$set(item, "currency", $$v)
                                      },
                                      expression: "item['currency']",
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass: "fa icon-right input-icon",
                                  }),
                                  item[`accountCurrencyStatus${index}`]
                                    ? _c(
                                        "small",
                                        { staticClass: "help text-danger" },
                                        [
                                          _vm._v(
                                            "The Currency " +
                                              _vm._s(index + 1) +
                                              " field is required."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md2" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item["balance"],
                                      expression: "item['balance']",
                                    },
                                  ],
                                  attrs: {
                                    name: "Balance",
                                    "data-vv-as": "Balance",
                                    autocomplete: "off",
                                    disabled: true,
                                  },
                                  domProps: { value: item["balance"] },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "balance",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "bank-balance" },
                                  },
                                  [_vm._v("Balance")]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.errors.has(
                                  `accountAmountWithdraw${index}`
                                ),
                                valid: _vm.isFormFieldValid(
                                  `accountAmountWithdraw${index}`
                                ),
                              },
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item["amount"],
                                      expression: "item['amount']",
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: `required|verifyWithdrawAmount:${index}`,
                                      expression:
                                        "`required|verifyWithdrawAmount:${index}`",
                                    },
                                  ],
                                  attrs: {
                                    name: `accountAmountWithdraw${index}`,
                                    "data-vv-as": `Amount for Withdrawal ${
                                      index + 1
                                    }`,
                                    autocomplete: "off",
                                    type: "text",
                                    required: "",
                                    oninput:
                                      "if(!value){value=''}else if(value.charAt(0)==='0'&&value.charAt(1)&&value.charAt(1)!=='.'){value='0'};value = value.replace(/[^\\d.]/g, '');value=value.replace(/\\.{2,}/g, '.');value=value.match(/^\\d*(\\.?\\d{0,2})/g)[0] || '';",
                                  },
                                  domProps: { value: item["amount"] },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "amount",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "accountAmountWithdraw" },
                                  },
                                  [_vm._v("Amount for Withdrawal")]
                                ),
                                _c("i", { staticClass: "bar" }),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          `accountAmountWithdraw${index}`
                                        ),
                                        expression:
                                          "errors.has(`accountAmountWithdraw${index}`)",
                                      },
                                    ],
                                    staticClass: "help text-danger",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          `accountAmountWithdraw${index}`
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "flex xs12 md3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _vm.virtualAccountData.length - 1 === index
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-micro",
                                        staticStyle: { "margin-right": "10px" },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addAccountCurrency(index)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fa fa-plus" })]
                                    )
                                  : _vm._e(),
                                _vm.virtualAccountData.length > 1
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-micro",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.minusAccountCurrency(
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fa fa-minus" })]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    _c("div", { staticClass: "va-row" }, [
                      _c("div", { staticClass: "flex xs12 md12" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group with-icon-right",
                            class: {
                              "has-error": _vm.errors.has("accountRemark"),
                              valid: _vm.isFormFieldValid("accountRemark"),
                            },
                          },
                          [
                            _c("div", { staticClass: "input-group" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.accountRemark,
                                    expression: "accountRemark",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  name: "accountRemark",
                                  "data-vv-as": "AccountRemark",
                                  autocomplete: "off",
                                  maxlength: "200",
                                  required: "",
                                },
                                domProps: { value: _vm.accountRemark },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.accountRemark = $event.target.value
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-check valid-icon icon-right input-icon",
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "accountRemark" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("t.remark"))
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("accountRemark"),
                                      expression: "errors.has('accountRemark')",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.errors.first("accountRemark"))
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }